import { Box, styled } from "@mui/material";

export const ListOfInstitutionsWrapper = styled(Box)(() => {
    return {
        "& .title-box": {
            marginBlockEnd: "var(--basic-margin)",
            overflow: "hidden",
        },
        "& thead tr": {
            backgroundColor: "#EBEBEB",
        },
        "tbody tr": {
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            "& td:last-child": {
                width: "10%",
                whiteSpace: "nowrap",
            }
        },
        "& form": {
            display: "flex",
            alignItems: "flex-end",
            cursor: "pointer",
            marginBlock: "calc(var(--basic-margin)/2) calc(var(--basic-margin))",
            "& .swap-icon": {
                height: "2rem",
                width: "auto",
                color: "#838383",
            },
            "& .search-icon-box": {
                padding: "calc(var(--basic-padding)/4)",
                background: "#D7D7D7",
                display: "flex",
            },
            "& .MuiInputBase-adornedStart": {
                padding: 0,
            },
            "& .MuiInputBase-inputAdornedStart": {
                minWidth: "18.75rem",
                padding: "calc(var(--basic-padding)/4)",
            },
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        },
        "@media screen and (min-width: 1024px)": {
            "& form": {
                justifyContent: "flex-end"
            }
        }
    }
})